import React, { useEffect, useState } from "react";
import {
  DefaultDoctorInterface,
  DoctorInterface,
  ShowDoctorContext,
} from "./types";
import { useDispatch } from "react-redux";
import { getDoctorsApi } from "../../redux/doctors/doctorApiCalls";
import DataDoctors from "./DataDoctors";
import AddDoctorModal from "./AddDoctorModal";
import { FaChevronCircleLeft, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router";
import { getCabinetsApi } from "../../redux/cabinets/cabinetApiCalls";
import SuccessMsg from "../../Messages/SuccessMsg";
import EditDoctorModal from "./EditDoctorModal";
import DeleteDoctorModal from "./DeleteDoctorModal";
import { getMedecinTypesApi } from "../../redux/medecinType/medecinTypeApiCalls";
import DisappearDoctorModal from "./DisappearDoctorModal";
import { useTranslation } from "react-i18next";

const ShowDoctors = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDisappearModal, setShowDisappearModal] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState<DoctorInterface>(
    DefaultDoctorInterface
  );

  const dispatch: any = useDispatch();

  useEffect(() => {
    const callAPIs = async () => {
      await dispatch(getDoctorsApi());
      await dispatch(getCabinetsApi());
      await dispatch(getMedecinTypesApi());
    };
    callAPIs();
  }, [dispatch]);

  const navigate = useNavigate();

  const { t } = useTranslation();

  return (
    <ShowDoctorContext.Provider
      value={{
        showSuccessMsg,
        setShowSuccessMsg,
        showAddModal,
        setShowAddModal,
        showEditModal,
        setShowEditModal,
        showDeleteModal,
        setShowDeleteModal,
        showDisappearModal,
        setShowDisappearModal,
        selectedDoctor,
        setSelectedDoctor,
      }}
    >
      <SuccessMsg
        modal={showSuccessMsg}
        toggle={() => setShowSuccessMsg(!showSuccessMsg)}
      />
      <div className="flex items-center gap-3">
        {/* Back Button */}
        <button
          onClick={() => navigate("/")}
          title={t("Retour")}
          className="p-2 rounded-full text-white transition"
          style={{ backgroundColor: "var(--mainColor)" }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "var(--mainColor-hover)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "var(--mainColor)")
          }
        >
          <FaChevronCircleLeft className="text-xl" />
        </button>

        {/* Add Button */}
        <button
          onClick={() => setShowAddModal(!showAddModal)}
          title={t("Ajouter")}
          className="p-2 rounded-full text-white transition"
          style={{ backgroundColor: "var(--secondColor)" }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "var(--secondColor-hover)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "var(--secondColor)")
          }
        >
          <FaPlus className="text-xl" />
        </button>
      </div>

      <DataDoctors />
      {showAddModal && (
        <AddDoctorModal
          modal={showAddModal}
          toggle={() => setShowAddModal(!showAddModal)}
        />
      )}
      {showEditModal && (
        <EditDoctorModal
          modal={showEditModal}
          toggle={() => setShowEditModal(!showEditModal)}
        />
      )}
      {showDeleteModal && (
        <DeleteDoctorModal
          modal={showDeleteModal}
          toggle={() => setShowDeleteModal(!showDeleteModal)}
        />
      )}
      {showDisappearModal && (
        <DisappearDoctorModal
          modal={showDisappearModal}
          toggle={() => setShowDisappearModal(!showDisappearModal)}
        />
      )}
    </ShowDoctorContext.Provider>
  );
};

export default ShowDoctors;
